









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Prop({ default: true }) closeable!: boolean;
  @Prop() header?: string;

  private close() {
    if (this.closeable) this.$emit('input', false);
  }
}
